// extracted by mini-css-extract-plugin
export default {"icon":"CustomViewTask_icon__9HZQB","field-icon":"CustomViewTask_field-icon__w2AgK","file-icon":"CustomViewTask_file-icon__XGJkS"};